import React from "react";
import { useSearchParams, Navigate } from "react-router-dom";
import { queryParamsUtils } from "../utils/navigationUtils";

/**
 * ManagementPage - Mantida para compatibilidade com links antigos
 * Redireciona query params para as novas rotas limpas
 */
export default function ManagementPage() {
  const [searchParams] = useSearchParams();
  
  // Extrair parâmetros da URL
  const tabParam = queryParamsUtils.getString(searchParams, 'tab');
  const actionParam = queryParamsUtils.getString(searchParams, 'action');
  const projectIdParam = queryParamsUtils.getNumber(searchParams, 'projectId');
  const projectNumberParam = queryParamsUtils.getString(searchParams, 'projectNumber');
  const clientIdParam = queryParamsUtils.getNumber(searchParams, 'clientId');
  const powerDistributionIdParam = queryParamsUtils.getNumber(searchParams, 'powerDistributionId');
  const engineerIdParam = queryParamsUtils.getNumber(searchParams, 'engineerId');

  // Redirecionar para novas rotas se houver query params
  if (tabParam) {
    let redirectPath = '/';
    let queryParams = new URLSearchParams();
    
    // Adicionar action se existir
    if (actionParam) {
      queryParams.set('action', actionParam);
    }
    
    switch (tabParam) {
      case 'project':
        redirectPath += 'projects';
        if (projectIdParam) {
          queryParams.set('projectId', projectIdParam.toString());
        } else if (projectNumberParam) {
          queryParams.set('projectNumber', projectNumberParam);
        }
        break;
      
      case 'client':
        redirectPath += 'integrators';
        if (clientIdParam) {
          queryParams.set('clientId', clientIdParam.toString());
        }
        break;
      
      case 'power-distribution':
        redirectPath += 'power-companies';
        if (powerDistributionIdParam) {
          queryParams.set('powerDistributionId', powerDistributionIdParam.toString());
        }
        break;
      
      case 'engineer':
        redirectPath += 'engineers';
        if (engineerIdParam) {
          queryParams.set('engineerId', engineerIdParam.toString());
        }
        break;
      
      case 'attorney':
        redirectPath += 'attorneys';
        break;
      
      default:
        redirectPath += 'projects';
    }
    
    const queryString = queryParams.toString();
    const fullPath = queryString ? `${redirectPath}?${queryString}` : redirectPath;
    
    return <Navigate to={fullPath} replace />;
  }

  // Se não houver query params, redirecionar para a primeira aba (Projetos)
  return <Navigate to="/projects" replace />;
}
